export interface GroupResource {
  name: string;
  url: string;
}

export interface DisplayGroup {
  id: string;
  name: string;
  icon?: 'housing' | 'manager' | 'lands';
  maps: GroupResource[];
  files: GroupResource[];
}

export interface PersonalInfoField {
  name: 'role' | 'name' | 'title' | 'email' | 'phone';
  label: string;
  editable: boolean;
}

export const PERSONAL_INFO_FIELDS: PersonalInfoField[] = [
  { name: 'role', label: 'Permission Status', editable: false },
  { name: 'name', label: 'Name', editable: true },
  { name: 'title', label: 'Title', editable: true },
  { name: 'email', label: 'Email', editable: true },
  { name: 'phone', label: 'Phone Number', editable: true },
];

// Placeholder design — groups management isn't wired to a service yet.
export const PROFILE_GROUPS: DisplayGroup[] = [
  {
    id: 'housing',
    name: 'Housing & Infrastructure',
    icon: 'housing',
    maps: [
      { name: 'Housing Services', url: '#' },
      { name: 'Infrastructure', url: '#' },
      { name: 'Land Claim', url: '#' },
    ],
    files: [
      { name: 'Data', url: '#' },
      { name: 'Notes', url: '#' },
    ],
  },
  {
    id: 'manager',
    name: 'Manager',
    icon: 'manager',
    maps: [{ name: 'Flood Claim', url: '#' }],
    files: [
      { name: 'Data', url: '#' },
      { name: 'Notes', url: '#' },
      { name: 'Videos', url: '#' },
    ],
  },
  {
    id: 'lands',
    name: 'Lands Council',
    icon: 'lands',
    maps: [
      { name: 'Housing Services', url: '#' },
      { name: 'Land Use Plan', url: '#' },
      { name: 'Land Claim', url: '#' },
    ],
    files: [{ name: 'Data', url: '#' }],
  },
];
